export function availableQuoteCourses(
  courses: any[] = [],
  bookedCourseIds: Array<number | string> = [],
  currentCourseId?: number | string | null
): any[] {
  const booked = bookedCourseIds.map(Number);
  const current = currentCourseId == null ? null : Number(currentCourseId);

  return courses.filter(course => {
    const courseId = Number(course.id);
    return courseId === current || !booked.includes(courseId);
  });
}

/**
 * The booking type as the event types name it, against the line type a quote
 * stores it under. Anything else is not something a quote can hold a line for.
 */
const LINE_TYPE_FOR_BOOKING: Record<string, string> = {
  Course: "course",
  "Online Course": "online_course",
  Audit: "audit"
};

/**
 * A quote's lines can be courses, online courses or audits, and the three draw
 * their ids from separate tables — so a line only prices a booking when it is
 * of the booking's own kind.
 */
export function quoteCoursePrice(
  courses: any[] = [],
  courseId?: number | string | null,
  lineType = "course"
): number | undefined {
  const course = courses.find(
    item =>
      Number(item.id) === Number(courseId) &&
      (item.lineType ?? "course") === lineType
  );
  return course && course.newPrice != null
    ? Number(course.newPrice)
    : undefined;
}

export function quoteBookingCompanies(
  quotes: any[],
  existingCompanies: any[],
  bookingType: string,
  courseId: number | string,
  cataloguePrice?: number | string
): any[] {
  const existing = new Map(
    existingCompanies.map(company => [String(company.companyId), company])
  );
  const lineType = LINE_TYPE_FOR_BOOKING[bookingType];
  const quotedCompanies = quotes.map(quote => {
    // A booking is charged at the rate its quote negotiated, whatever kind of
    // thing is being booked. A quote that does not carry a line for it keeps
    // whatever was already saved, and failing that the catalogue price.
    const quoted = lineType
      ? quoteCoursePrice(quote.courses, courseId, lineType)
      : undefined;
    const saved = existing.get(String(quote.companyId));

    return {
      ...(saved || {}),
      companyId: quote.companyId,
      price: quoted ?? saved?.price ?? cataloguePrice
    };
  });
  return [
    ...quotedCompanies,
    ...existingCompanies.filter(
      company =>
        company.isPrivate &&
        !quotedCompanies.some(
          quoted => String(quoted.companyId) === String(company.companyId)
        )
    )
  ];
}
